import { Typography, TypographyProps } from '@mui/material';
import { PropsWithChildren } from 'react';

export const ChatTitle = ({ children, paddingBottom = 2 }: PropsWithChildren<TypographyProps>) => {
  if (typeof children === 'string') {
    return (
      <Typography
        sx={{
          paddingBottom: paddingBottom,
          fontWeight: 'bold',
        }}
      >
        {children}
      </Typography>
    );
  }

  return children;
};
